var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-setting-page"},[_c('tabHeader',{attrs:{"slideData":_vm.slideData,"tab":_vm.tab},on:{"headerTabBack":_vm.headerTabBack}}),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c(_vm.tab,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }